import { Row, SizedBox } from "../CommonBaseComponents";
import { C4Text } from "../text/CustomText";
import { Theme } from "../../Theme";

function CustomSegmentedControl({ currentValue, setValue, values, isDeparted = false }) {
    if (isDeparted) {
        return (
            <SizedBox backgroundColor={"transparent"} width={"100%"} height={"36px"} borderRadius={"8px"}>
                <Row justifyContent={"space-between"} width={"100%"} padding={"0 3px"} gap={"2px"}>
                    {values.map((v) => (
                        <SizedBox
                            width={"auto"}
                            height={"auto"}
                            backgroundColor={currentValue === v.value ? Theme.color.neutral100 : Theme.color.neutral100}
                            hoverBackgroundColor={currentValue === v.value ? undefined : Theme.color.zinc100}
                            borderRadius={"8px"}
                            border={currentValue === v.value ? `1px solid ${Theme.color.indigo500}` : "none"}
                            cursor={"pointer"}
                            onClick={() => {
                                setValue(v.value);
                            }}
                            padding={"9px 12px"}
                        >
                            <C4Text fontColor={currentValue === v.value ? Theme.color.indigo700 : Theme.color.gray500}>
                                {v.label}
                            </C4Text>
                        </SizedBox>
                    ))}
                </Row>
            </SizedBox>
        );
    }

    return (
        <SizedBox backgroundColor={Theme.color.neutral100} width={"auto"} height={"36px"} borderRadius={"8px"}>
            <Row justifyContent={"space-between"} width={"100%"} padding={"0 3px"} gap={"2px"}>
                {values.map((v) => (
                    <SizedBox
                        width={"auto"}
                        height={"30px"}
                        backgroundColor={currentValue === v.value ? Theme.color.white : "transparent"}
                        hoverBackgroundColor={currentValue === v.value ? undefined : Theme.color.zinc100}
                        borderRadius={"8px"}
                        border={currentValue === v.value ? `1px solid ${Theme.color.gray200}` : "none"}
                        cursor={"pointer"}
                        onClick={() => {
                            setValue(v.value);
                        }}
                        padding={"0 15px"}
                    >
                        <C4Text fontColor={currentValue === v.value ? Theme.color.gray500 : Theme.color.gray400}>
                            {v.label}
                        </C4Text>
                    </SizedBox>
                ))}
            </Row>
        </SizedBox>
    );
}

export default CustomSegmentedControl;
